<template>
  <svg
    class="opportunity-temperature-icon"
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient :id="outerGradientId" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" :stop-color="palette.outer[0]" />
        <stop offset="100%" :stop-color="palette.outer[1]" />
      </linearGradient>
      <linearGradient :id="innerGradientId" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" :stop-color="palette.inner[0]" />
        <stop offset="100%" :stop-color="palette.inner[1]" />
      </linearGradient>
    </defs>
    <path
      :fill="`url(#${outerGradientId})`"
      d="M16.4 2C17.3 6.6 21.3 9.4 23.9 13.3C27.2 18.2 26 24.8 21.2 28C18.2 30 13.8 30 10.8 28C6.2 24.9 5.3 18.7 8.3 14.3C8.9 16.4 10.3 17.9 12.2 18.4C11.1 12.4 13.1 6.3 16.4 2Z"
    />
    <path
      :fill="`url(#${innerGradientId})`"
      d="M16.3 13.6C17.2 16.8 20.1 18.4 20.7 21.7C21.3 25 19.1 27.8 16 27.8C12.9 27.8 10.8 25.3 11.4 22.3C11.8 20.6 12.8 19.4 13.9 18.8C13.9 20.2 14.5 21.3 15.4 21.6C14.8 18.9 15.1 16 16.3 13.6Z"
    />
  </svg>
</template>

<script>
import { DEFAULT_OPPORTUNITY_TEMPERATURE } from 'dashboard/helper/opportunityTemperatureHelper';

const PALETTES = {
  cold: { outer: ['#6FA8FF', '#1E4FD8'], inner: ['#DCEBFF', '#7FB2FF'] },
  warm: { outer: ['#A8A29E', '#F28C28'], inner: ['#FFE7B0', '#F7B544'] },
  hot: { outer: ['#FF8A3D', '#D7261E'], inner: ['#FFE38F', '#FF9A3C'] },
};

let instanceCount = 0;

export default {
  name: 'OpportunityTemperatureIcon',
  props: {
    temperature: {
      type: String,
      default: DEFAULT_OPPORTUNITY_TEMPERATURE,
    },
    size: {
      type: [Number, String],
      default: 32,
    },
  },
  data() {
    instanceCount += 1;
    return { instanceId: instanceCount };
  },
  computed: {
    palette() {
      return (
        PALETTES[this.temperature] || PALETTES[DEFAULT_OPPORTUNITY_TEMPERATURE]
      );
    },
    outerGradientId() {
      return `opportunity-temperature-outer-${this.temperature}-${this.instanceId}`;
    },
    innerGradientId() {
      return `opportunity-temperature-inner-${this.temperature}-${this.instanceId}`;
    },
  },
};
</script>
